export enum CUSTOM_API_QUERY {
    EVENTS = 'EVENTS',
    RELOADS = 'RELOADS',
}
